import { useState } from "react";
import Navbar from "../../Components/Navbar/index";
import { ChevronDown } from "lucide-react";
import Footer from "../../Components/Footer";

interface FAQItem {
  question: string;
  answer: string;
}

export default function FAQ() {
  const [active, setActive] = useState<number | null>(null);

  const faqs: FAQItem[] = [
    {
      question: "Bagaimana cara melakukan pemesanan produk?",
      answer: "Anda dapat melakukan pemesanan dengan memilih produk yang diinginkan, kemudian mengisi data pemesanan seperti nama, alamat, dan nomor telepon. Setelah itu pesanan akan diproses oleh tim kami.",
    },
    {
      question: "Apakah produk yang dijual ready stock?",
      answer: "Sebagian besar produk yang tersedia di website kami merupakan produk ready stock. Namun pada kondisi tertentu stok dapat berubah sewaktu-waktu.",
    },
    {
      question: "Berapa lama proses pengiriman?",
      answer: "Proses pengiriman biasanya memakan waktu 1-3 hari kerja setelah pesanan dikonfirmasi, tergantung pada lokasi tujuan pengiriman.",
    },
    {
      question: "Apakah bisa melakukan penukaran ukuran?",
      answer: "Penukaran ukuran dapat dilakukan selama produk belum digunakan dan masih dalam kondisi asli. Silakan hubungi customer service kami untuk proses penukaran.",
    },
    {
      question: "Metode pembayaran apa saja yang tersedia?",
      answer: "Kami menyediakan berbagai metode pembayaran seperti transfer bank, e-wallet, dan pembayaran lainnya yang tersedia pada halaman checkout.",
    },
  ];

  const toggleFAQ = (index: number) => {
    setActive(active === index ? null : index);
  };

  return (
    <>
      <Navbar />

      <section className="max-w-4xl mx-auto px-4 pt-32 max-sm:pt-24 pb-16 font-signika">
        {/* TITLE */}
        <div className="text-center mb-6">
          <h1 className="text-3xl md:text-4xl font-bold mb-3">
            <span className="text-primary">Frequently</span> Asked Questions
          </h1>
          <p className="text-gray-500">Beberapa pertanyaan yang sering ditanyakan oleh pelanggan kami.</p>
        </div>

        {/* FAQ */}
        <div className="space-y-4">
          {faqs.map((faq, index) => {
            const open = active === index;

            return (
              <div key={index} className="border rounded-xl overflow-hidden">
                <button onClick={() => toggleFAQ(index)} className="w-full flex justify-between items-center p-5 text-left font-semibold">
                  {faq.question}

                  <ChevronDown className={`transition transform ${open ? "rotate-180" : ""}`} />
                </button>

                {open && <div className="px-5 pb-5 text-gray-600 leading-relaxed">{faq.answer}</div>}
              </div>
            );
          })}
        </div>
      </section>

      <Footer />
    </>
  );
}
